import { ReactElement, ReactNode } from 'react';
import { Stack, Typography, TypographyProps } from '@mui/material';

type PriceWithDiscountProps = {
  discountedPrice: string;
  price?: string;
  suffix?: ReactNode;
  gap?: number;
  discountedPriceProps?: TypographyProps;
  priceProps?: TypographyProps;
};

export const PriceWithDiscount = ({
  discountedPrice,
  price,
  suffix,
  gap = 1,
  discountedPriceProps,
  priceProps,
}: PriceWithDiscountProps): ReactElement => {
  const priceSx = priceProps?.sx ?? {};

  return (
    <Stack direction="row" alignItems="center" gap={gap}>
      {price && (
        <Typography {...priceProps} sx={{ textDecoration: 'line-through', ...priceSx }}>
          {price}
        </Typography>
      )}
      <Typography {...discountedPriceProps}>{discountedPrice}</Typography>
      {suffix}
    </Stack>
  );
};
